import { render, staticRenderFns } from "./studentPaymentStatistics.vue?vue&type=template&id=6f121bea&scoped=true"
import script from "./studentPaymentStatistics.vue?vue&type=script&lang=js"
export * from "./studentPaymentStatistics.vue?vue&type=script&lang=js"
import style0 from "./studentPaymentStatistics.vue?vue&type=style&index=0&id=6f121bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f121bea",
  null
  
)

export default component.exports